import {
    Search,
    Target,
    User,
    Heart,
    Sparkles,
    Shield,
    Flame,
    DoorOpen,
} from "lucide-react";

import type { TherapeuticStage } from "~/database/types";

// AIDEV-NOTE: Maps therapeutic stage enum values to human-readable labels and icons.
// Canonical taxonomy (EVO-1910, exile-front revision): 6 Fs (+ follow-through) for Protectors;
// for Exiles the first rung is `access` (post-permission connection), then Unburdening. The old
// shared find/focus/flesh_out front is protector-specific; feel_toward is a recurring gate on both
// tracks but a rung only on protectors. `protector_checkin` is a RETAINED legacy key (renamed →
// protector_unburdening_integration) so ~35 historical part_interactions rows still render a
// badge. This Record must stay EXHAUSTIVE over TherapeuticStage.
export const THERAPEUTIC_STAGE_CONFIG: Record<
    TherapeuticStage,
    { label: string; icon: typeof Search; color: string; framework: string }
> = {
    // --- Protector 6 Fs front (steps 1-4; protector-specific, not an exile front) ---
    find: {
        label: "Find",
        icon: Search,
        color: "text-blue-500",
        framework: "6F",
    },
    focus: {
        label: "Focus",
        icon: Target,
        color: "text-purple-500",
        framework: "6F",
    },
    flesh_out: {
        label: "Flesh Out",
        icon: User,
        color: "text-amber-500",
        framework: "6F",
    },
    feel_toward: {
        label: "Feel Toward",
        icon: Heart,
        color: "text-rose-400",
        framework: "6F",
    },
    // --- Protector 6 Fs + follow-through ---
    befriend: {
        label: "Befriend",
        icon: Sparkles,
        color: "text-emerald-500",
        framework: "6F",
    },
    explore_fears: {
        label: "Fears",
        icon: Shield,
        color: "text-orange-500",
        framework: "6F",
    },
    permission: {
        label: "Permission",
        icon: Target,
        color: "text-teal-500",
        framework: "6F",
    },
    // --- Exile first rung (post-permission connection; replaces the old shared 4F front) ---
    access: {
        label: "Access",
        icon: DoorOpen,
        color: "text-cyan-500",
        framework: "Unburdening",
    },
    // --- Exile unburdening sequence ---
    witness: {
        label: "Witness",
        icon: Heart,
        color: "text-rose-500",
        framework: "Unburdening",
    },
    do_over: {
        label: "Do-Over",
        icon: Sparkles,
        color: "text-amber-500",
        framework: "Unburdening",
    },
    retrieval: {
        label: "Retrieval",
        icon: User,
        color: "text-purple-500",
        framework: "Unburdening",
    },
    unburden: {
        label: "Unburdening",
        icon: Flame,
        color: "text-orange-500",
        framework: "Unburdening",
    },
    invite_qualities: {
        label: "New Qualities Invitation",
        icon: Sparkles,
        color: "text-emerald-500",
        framework: "Unburdening",
    },
    // --- Shared terminal rung ---
    protector_unburdening_integration: {
        label: "Post-Unburdening Check-In",
        icon: Shield,
        color: "text-blue-500",
        framework: "Unburdening",
    },
    // --- Legacy key (historical rows only; renamed → protector_unburdening_integration) ---
    protector_checkin: {
        label: "Post-Unburdening Check-In",
        icon: Shield,
        color: "text-blue-500",
        framework: "Unburdening",
    },
};
